import { RotatingLines } from 'react-loader-spinner';
import './css/loader.css';

const Loader = () => {
  return (
    <div className="loader-overlay">
      <RotatingLines
        strokeColor="#50CD89"
        strokeWidth="5"
        animationDuration="0.75s"
        width="96"
        visible={true}
      />
    </div>
  );
};

export default Loader;